import React from 'react';
import MuiDrawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import useModalFocusHandler from '../../hooks/useModalFocusHandler';

const getContainerQuerySelector = anchor => {
  return anchor === 'bottom'
    ? '.MuiDrawer-paperAnchorBottom:not(.MuiDrawer-paperAnchorDockedBottom)'
    : '.MuiDrawer-paperAnchorRight:not(.MuiDrawer-paperAnchorDockedRight)';
};

const RepliconDrawer = ({
  open,
  children,
  trapFocusWithDatePicker,
  anchor = 'right',
  ...drawerProps
}) => {
  useModalFocusHandler({
    isOpen: open,
    containerQuerySelector: getContainerQuerySelector(anchor),
    trapFocusWithDatePicker
  });

  return (
    <MuiDrawer
      open={open}
      anchor={anchor}
      disableEnforceFocus={trapFocusWithDatePicker}
      {...drawerProps}
    >
      {children}
    </MuiDrawer>
  );
};

RepliconDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  trapFocusWithDatePicker: PropTypes.bool,
  children: PropTypes.node.isRequired,
  anchor: PropTypes.oneOf(['right', 'bottom'])
};

export default RepliconDrawer;
